import {
  Popover,
  PopoverContent,
  PopoverTrigger
} from "./chunk-JKIHJFJD.mjs";
import {
  IconButton
} from "./chunk-4IBR4GAB.mjs";
import {
  MoreHorizontal_default
} from "./chunk-RBD6MIHX.mjs";
import {
  Close_default
} from "./chunk-ONOYXPIT.mjs";
import {
  cn
} from "./chunk-DYSUVPH5.mjs";

// src/components/sheet/sheet.tsx
import * as SheetPrimitive from "@radix-ui/react-dialog";
import { cva } from "class-variance-authority";
import React, {
  forwardRef
} from "react";
var Sheet = SheetPrimitive.Root;
var SheetTrigger = SheetPrimitive.Trigger;
var SheetClose = SheetPrimitive.Close;
var SheetPortal = SheetPrimitive.Portal;
var SheetOverlay = forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React.createElement(
  SheetPrimitive.Overlay,
  {
    className: cn(
      "fixed inset-0 z-50 bg-black/60 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      className
    ),
    ...props,
    ref
  }
));
var sheetVariants = cva(
  "fixed z-50 bg-surface text-foreground shadow-lg transition ease-in-out data-[state=closed]:duration-300 data-[state=open]:duration-500 data-[state=open]:animate-in data-[state=closed]:animate-out",
  {
    variants: {
      side: {
        top: "inset-x-0 top-0 border-b data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top",
        bottom: "inset-x-0 bottom-0 border-t data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom",
        left: "inset-y-0 left-0 h-full w-3/4 border-r data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left sm:max-w-sm",
        right: "inset-y-0 right-0 h-full w-3/4  border-l data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-sm"
      }
    },
    defaultVariants: {
      side: "right"
    }
  }
);
var SheetContent = forwardRef(
  ({
    side = "right",
    transparentOverlay = false,
    className,
    children,
    ...props
  }, ref) => /* @__PURE__ */ React.createElement(SheetPortal, null, /* @__PURE__ */ React.createElement(SheetOverlay, { className: cn({ "bg-transparent": transparentOverlay }) }), /* @__PURE__ */ React.createElement(
    SheetPrimitive.Content,
    {
      ref,
      className: cn(sheetVariants({ side }), className),
      ...props
    },
    children
  ))
);
var SheetHeader = ({
  children,
  className,
  actions,
  dropdownActions,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "div",
  {
    className: cn("flex items-center gap-4 px-6 py-4", className),
    ...props
  },
  /* @__PURE__ */ React.createElement("div", { className: "grow space-y-2" }, children),
  /* @__PURE__ */ React.createElement("div", { className: "flex shrink-0 items-center gap-4" }, actions, dropdownActions && /* @__PURE__ */ React.createElement(Popover, null, /* @__PURE__ */ React.createElement(PopoverTrigger, { asChild: true }, /* @__PURE__ */ React.createElement(IconButton, { type: "button" }, /* @__PURE__ */ React.createElement(MoreHorizontal_default, null))), /* @__PURE__ */ React.createElement(
    PopoverContent,
    {
      align: "end",
      alignOffset: -2,
      className: "min-w-[220px]"
    },
    dropdownActions
  )), /* @__PURE__ */ React.createElement(SheetPrimitive.Close, { asChild: true }, /* @__PURE__ */ React.createElement(IconButton, { type: "button", className: "disabled:pointer-events-none" }, /* @__PURE__ */ React.createElement(Close_default, null))))
);
var SheetTitle = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React.createElement(
  SheetPrimitive.Title,
  {
    ref,
    className: cn("text-foreground my-heading-xs", className),
    ...props
  }
));
var SheetDescription = forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React.createElement(
  SheetPrimitive.Description,
  {
    ref,
    className: cn("text-foreground-subtle my-body-sm", className),
    ...props
  }
));

export {
  Sheet,
  SheetTrigger,
  SheetClose,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription
};
